var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('Page',{attrs:{"title":"My Reviews"},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('YearSelector',{on:{"select":_vm.load}})]},proxy:true}])},[_c('List',{attrs:{"reviews":_vm.reviews}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }